export class Servico {
  ativado = true;
  codigo = null;
  nome = null;
  descricao = null;
  grupoServicoId = null;
  grupoTributarioId = null;
  estCodigoServicoNacionalId = null;
  estClassificacaoServicoNacionalId = null;
  precoServico = null;
  custoOperacionalIndireto = 0;
  comissao = 0;
  issIbsCbs = 0;
  taxaCartao = 0;
  taxaAdm = 0;
  lucro = 0;
  precificacoes = [];
  servicoRecorrente = false;
  prazoRecorrencia = null;
  tempoAntecedencia = null;
  tempoExecucao = null;
  aliquotaTotalSimplesNacional = 0;
  codigoServicoMunicipal = null;

  constructor(servico) {
    this.ativado = servico.ativado;
    this.codigo = servico.codigo;
    this.nome = servico.nome;
    this.descricao = servico.descricao;
    this.grupoServicoId = servico.grupoServicoId;
    this.grupoTributarioId = servico.grupoTributarioId;
    this.estCodigoServicoNacionalId = servico.estCodigoServicoNacionalId;
    this.estClassificacaoServicoNacionalId =
      servico.estClassificacaoServicoNacionalId;
    this.precoServico = servico.precoServico;
    this.custoOperacionalIndireto = servico.custoOperacionalIndireto || 0;
    this.comissao = servico.comissao || 0;
    this.issIbsCbs = servico.issIbsCbs || 0;
    this.taxaCartao = servico.taxaCartao || 0;
    this.taxaAdm = servico.taxaAdm || 0;
    this.lucro = servico.lucro || 0;
    this.precificacoes = servico.precificacoes || [];
    this.servicoRecorrente = servico.servicoRecorrente;
    this.prazoRecorrencia = servico.prazoRecorrencia;
    this.aliquotaTotalSimplesNacional =
      servico.aliquotaTotalSimplesNacional || 0;
    if (servico.tempoAntecedencia) {
      const { tempo, unidade } = this.parseTempoAntecedencia(
        servico.tempoAntecedencia,
      );
      this.tempoAntecedencia = tempo;
      this.unidadeTempoAntecedencia = unidade;
    }
    if (servico.tempoExecucao) {
      const { tempo, unidade } = this.parseTempoExecucao(servico.tempoExecucao);
      this.tempoExecucao = tempo;
      this.unidadeTempoExecucao = unidade;
    }
    if (servico.codigoServicoMunicipal) {
      this.codigoServicoMunicipal = servico.codigoServicoMunicipal;
    }
  }

  parseTempoAntecedencia(tempo) {
    if (tempo % 24 === 0) {
      return { tempo: parseInt(tempo / 24), unidade: "DIA" };
    }

    return { tempo, unidade: "HORA" };
  }

  parseTempoExecucao(tempo) {
    if (tempo % 60 === 0) {
      return { tempo: parseInt(tempo / 60), unidade: "HORA" };
    }

    return { tempo, unidade: "MIN" };
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setHandleChangeSwitch(name, checked) {
    this[name] = checked;
  }

  setHandleChangeAutoComplete(name, value) {
    this[name] = value ? value.id : null;
  }

  setPrecificacao(precificacao, params) {
    this.precificacoes = precificacao || [];
    this.custoOperacionalIndireto = params.custoOperacionalIndireto || 0;
    this.comissao = params.comissao || 0;
    this.issIbsCbs = params.issIbsCbs || 0;
    this.taxaCartao = params.taxaCartao || 0;
    this.taxaAdm = params.taxaAdm || 0;
    this.lucro = params.lucro || 0;
    this.precoServico = params.precoServico;
  }

  converterUnidadesTempo() {
    if (this.tempoAntecedencia && this.unidadeTempoAntecedencia === "DIA") {
      this.tempoAntecedencia *= 24;
    }

    if (this.tempoExecucao && this.unidadeTempoExecucao === "HORA") {
      this.tempoExecucao *= 60;
    }
  }
}
